import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { getAlarmById } from '../../../../../js/api/getRules'
import moment from 'moment'

interface ExecutionTextProps {
    text: string
    value: string
    textColor: string
    ruleAlarm?: boolean
}

export function ExecutionText({ text, value, textColor, ruleAlarm = false }): JSX.Element {
    const [executeValue, setExecuteValue] = useState('')

    useEffect(() => {
        if (ruleAlarm) {
            getAlarmById(parseInt(value))
                .then(resolve => {
                    const formattedRule = resolve.name + ' (ID  - ' + value.padStart(4, '0') + ') triggered'
                    setExecuteValue(formattedRule)
                })
                .catch(reject => console.log('Erro - ', reject))
        } else {
            const dateFormatted = moment(value).format('ddd MMM DD YYYY HH:mm:ss')
            setExecuteValue(dateFormatted)
        }
    }, [ruleAlarm])

    return (
        <MailFrequencyContainer textColor={textColor}>
            <span className="executed-text">{text}</span>
            <span>{executeValue}</span>
        </MailFrequencyContainer>
    )
}

const MailFrequencyContainer = styled.div<{ textColor: string }>`
    display: flex;
    flex-direction: column;
    font-size: 12px;

    .executed-text {
        font-style: italic;
        color: var(--${tc => tc.textColor}-700);
        font-weight: 600;
    }
`
